<template>
    <div class="profile-page profile-page--overview">
        <PageHeader icon="fas fa-user-circle">
            <template #title>Profil Saya</template>
            <template #subtitle>Informasi akun dan identitas Anda di Medhop.</template>
            <template #actions>
                <b-button class="profile-page__secondary-action" @click="$router.push('/profile/security')">
                    <i class="fas fa-mobile-alt mr-2"></i>Keamanan Akun
                </b-button>
                <b-button class="profile-page__secondary-action" @click="$router.push('/profile/change-password')">
                    <i class="fas fa-shield-alt mr-2"></i>Ubah Password
                </b-button>
                <b-button class="profile-page__primary-action" @click="$router.push('/profile/change-profile')">
                    <i class="fas fa-user-edit mr-2"></i>Edit Profil
                </b-button>
            </template>
        </PageHeader>

        <Card card-class="profile-content-card" body-class="profile-content-card__body">
            <template #body>
                <div class="profile-overview">
                    <aside class="profile-identity-panel">
                        <div class="profile-avatar profile-avatar--large">
                            <img :src="profilePhoto" :alt="`Foto profil ${displayValue(data.name)}`" @error="useDefaultAvatar" />
                            <span class="profile-avatar__status" title="Akun aktif"></span>
                        </div>
                        <span class="profile-identity-panel__eyebrow">Profil Pengguna</span>
                        <h2>{{ displayValue(data.name) }}</h2>
                        <p>{{ profileRole }}</p>
                        <span class="profile-identity-panel__badge">
                            <i class="fas fa-check-circle mr-2"></i>Akun Aktif
                        </span>
                    </aside>

                    <section class="profile-information">
                        <div class="profile-section-heading">
                            <span class="profile-section-heading__icon"><i class="fas fa-id-card"></i></span>
                            <div>
                                <h3>Informasi Pribadi</h3>
                                <p>Data utama yang terhubung dengan akun Anda.</p>
                            </div>
                        </div>

                        <dl class="profile-details-grid">
                            <div v-for="item in profileDetails" :key="item.label" :class="['profile-detail-item', { 'profile-detail-item--wide': item.wide }]">
                                <span class="profile-detail-item__icon"><i :class="item.icon"></i></span>
                                <div>
                                    <dt>{{ item.label }}</dt>
                                    <dd>{{ displayValue(item.value) }}</dd>
                                </div>
                            </div>
                        </dl>
                    </section>
                </div>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from "@/view/content/Card.vue";
import { getUser } from "@/core/services/jwt.service";

export default {
    components: { Card },
    data() {
        return {
            data: getUser() || {},
            defaultAvatar: "/media/users/user-default.svg",
        };
    },
    computed: {
        profilePhoto() {
            return this.data.photo || this.defaultAvatar;
        },
        profileRole() {
            return this.data.position_name || this.data.polyclinic_name || this.data.department_name || "Pengguna Klinik";
        },
        profileDetails() {
            return [
                { label: "Nama Lengkap", value: this.data.name, icon: "fas fa-user" },
                { label: "Email", value: this.data.email, icon: "fas fa-envelope" },
                { label: "Nomor Handphone", value: this.data.phone, icon: "fas fa-phone-alt" },
                { label: "Poliklinik", value: this.data.polyclinic_name, icon: "fas fa-clinic-medical" },
                { label: "Alamat", value: this.data.address, icon: "fas fa-map-marker-alt", wide: true },
            ];
        },
    },
    methods: {
        displayValue(value) {
            return value || "Belum tersedia";
        },
        useDefaultAvatar(event) {
            if (!event.target.src.endsWith(this.defaultAvatar)) event.target.src = this.defaultAvatar;
        },
    },
};
</script>

<style lang="scss" src="@/assets/sass/pages/_profile-pages.scss"></style>
